import styled from "styled-components";
import signUpImage from "assets/images/signUpImage.png"

export const Wrapper = styled.div`

    --color-primary-dark: #14092D;

    * {
        font-family: Inter, sans-serif;
        pointer-events: auto!important;
    }

    .install-modal-header {
        h2 {

        }
    }

    .welcome-hero {
        background-position: center !important;
        background-repeat: no-repeat !important;
        background-blend-mode: normal, normal !important;
        background-size: contain !important;
        height: calc(100vh - 300px);
        min-height: 175px;
        position: relative;
        z-index: 10;
    }

    .welcome-hero::after {
        content: "";
        position: absolute;
        width: 100%;
        bottom: 0;
        left: 0;
        right: 0;
        height: 100%;
        z-index: -10;
        background: linear-gradient(#0D02275C 10%, var(--color-primary-dark) 80%);
        //background: linear-gradient(transparent 0, var(--color-primary-dark) 90%), linear-gradient(transparent 0, var(--color-primary-dark) 90%)
    }

    ${({theme}: { theme: any }) => theme.breakpoints.down("md")} {
        //.welcome-hero {
        //    height: 450px;
        //}
    }

    svg {
        width: initial;
    }

    .install-modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.24);
        backdrop-filter: blur(10px);
        animation: fadeIn 0.3s ease;
        color: var(--color-text);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 100000;
        overflow: hidden;
    }

    .ios-instructions {
    }

    h1, h2, h3, h4, h5, h6, p, li {
        color: #FFFFFF;
    }

    a, strong {
        color: #F9FAFB;
    }

    .install-modal {
        overflow-y: auto;
        overflow-x: hidden;
        background: var(--color-primary-dark);
        width: 100%;
        box-shadow: 0 25px 50px rgba(0, 0, 0, 0.3);
        animation: slideUp 0.3s ease;
        max-height: calc(100vh - 16px);
        height: 100%;
        color: white;
        position: relative;

        &::-webkit-scrollbar {
            appearance: none;
        }

        &::-webkit-scrollbar-track {
            appearance: none;
        }
    }

    .install-modal-header h2 {
        margin: 0;
        flex: 1;
        color: white;
    }

    .install-buttons {
        z-index: 10;
        inset: 0;
        top: 0px;
        top: unset;
        text-align: center;
        --color-primary-dark: #1B0A44;
        background: linear-gradient(transparent 0, var(--color-primary-dark) 90%), linear-gradient(transparent 0, var(--color-primary-dark) 90%);
        flex-direction: column;
        align-items: center;
        gap: 4px;
        display: flex;
        padding: 2rem 1.25rem 1.25rem;
        position: sticky;
        bottom: 0;
        left: 0;
        right: 0;
        margin-top: auto;
        z-index: 10;
    }

    @keyframes fadeIn {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }

    @keyframes slideUp {
        from {
            opacity: 0;
            transform: translateY(20px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    .features {
        .swiper-slide * {
            font-family: var(--font-grotesk);
        }
    }

    ${({theme}: { theme: any }) => theme.breakpoints.down("md")} {
        .install-modal {
            max-height: 100vh;
            overflow-y: auto;
        }
    }

    import styled from "styled-components";

    export const Wrapper

= styled . div \` --color-primary-dark: #14092D;

    * {
        font-family: Inter, sans-serif;
    }

    .install-modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.8);
        backdrop-filter: blur(10px);
        //z-index: 30;
    }

    .install-modal {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        background: var(--color-primary-dark);
        width: 100%;
        box-shadow: 0 -10px 30px rgba(0, 0, 0, 0.3);
        max-height: 90vh;
        height: auto;
        color: white;
        z-index: 31;
        overflow-y: auto;
        overflow-x: hidden;

        @media (min-width: 768px) {
            position: relative;
            max-height: calc(100vh - 16px);
            height: 100%;
            border-radius: 1.5rem;
            margin: auto;
        }

        &::-webkit-scrollbar {
            display: none;
        }
    }

    /* Rest of your existing styles remain the same */

    .welcome-hero {
        background-position: center !important;
        background-repeat: no-repeat !important;
        background-blend-mode: normal, normal !important;
        background-size: contain !important;
        height: calc(100vh - 300px);
        min-height: 175px;
        position: relative;
        z-index: 10;
    }

    .welcome-hero::after {
        content: "";
        position: absolute;
        width: 100%;
        bottom: 0;
        left: 0;
        right: 0;
        height: 100%;
        z-index: -10;
`